/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain a copy
 * of the license at https://github.com/palantir/blueprint/blob/master/LICENSE
 * and https://github.com/palantir/blueprint/blob/master/PATENTS
 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classNames = require("classnames");
var PureRender = require("pure-render-decorator");
var React = require("react");
var core_1 = require("@blueprintjs/core");
var _1 = require("../");
var Classes = require("../../common/classes");
var Omnibox = Omnibox_1 = (function (_super) {
    tslib_1.__extends(Omnibox, _super);
    function Omnibox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            query: "",
        };
        _this.TypedQueryList = _1.QueryList.ofType();
        _this.refHandlers = {
            queryList: function (ref) { return _this.queryList = ref; },
        };
        _this.renderQueryList = function (listProps) {
            var _a = _this.props, _b = _a.inputProps, inputProps = _b === void 0 ? {} : _b, isOpen = _a.isOpen, _c = _a.overlayProps, overlayProps = _c === void 0 ? {} : _c;
            var query = _this.state.query;
            var ref = inputProps.ref, htmlInputProps = tslib_1.__rest(inputProps, ["ref"]);
            var handleKeyDown = listProps.handleKeyDown, handleKeyUp = listProps.handleKeyUp;
            var handlers = isOpen && query.length > 0
                ? { onKeyDown: handleKeyDown, onKeyUp: handleKeyUp }
                : {};
            return (React.createElement(core_1.Overlay, tslib_1.__assign({ hasBackdrop: true }, overlayProps, { isOpen: isOpen, className: classNames(overlayProps.className, Classes.OMNIBOX_OVERLAY), onClose: _this.handleOverlayClose }),
                React.createElement("div", tslib_1.__assign({ className: classNames(listProps.className, Classes.OMNIBOX) }, handlers),
                    React.createElement(core_1.InputGroup, tslib_1.__assign({ autoFocus: true, className: core_1.Classes.LARGE, leftIconName: "search", placeholder: "Search...", value: listProps.query }, htmlInputProps, { onChange: _this.handleQueryChange })),
                    _this.maybeRenderMenu(listProps))));
        };
        _this.handleActiveItemChange = function (activeItem) { return _this.setState({ activeItem: activeItem }); };
        _this.handleItemSelect = function (item, event) {
            if (_this.state.query.length > 0) {
                core_1.Utils.safeInvoke(_this.props.onItemSelect, item, event);
            }
        };
        _this.handleQueryChange = function (event) {
            var _a = _this.props.inputProps, inputProps = _a === void 0 ? {} : _a;
            _this.setState({ query: event.currentTarget.value });
            core_1.Utils.safeInvoke(inputProps.onChange, event);
        };
        _this.handleOverlayClose = function (event) {
            core_1.Utils.safeInvoke(_this.props.onClose, event);
        };
        return _this;
    }
    Omnibox.ofType = function () {
        return Omnibox_1;
    };
    Omnibox.prototype.render = function () {
        // omit props specific to this component, spread the rest.
        var _a = this.props, isOpen = _a.isOpen, itemRenderer = _a.itemRenderer, inputProps = _a.inputProps, noResults = _a.noResults, overlayProps = _a.overlayProps, restProps = tslib_1.__rest(_a, ["isOpen", "itemRenderer", "inputProps", "noResults", "overlayProps"]);
        return React.createElement(this.TypedQueryList, tslib_1.__assign({}, restProps, { activeItem: this.state.activeItem, onActiveItemChange: this.handleActiveItemChange, onItemSelect: this.handleItemSelect, query: this.state.query, ref: this.refHandlers.queryList, renderer: this.renderQueryList }));
    };
    Omnibox.prototype.componentWillReceiveProps = function (nextProps) {
        var isOpen = nextProps.isOpen;
        var canClearQuery = !this.props.isOpen && isOpen && this.props.resetOnSelect;
        this.setState({
            activeItem: canClearQuery ? this.props.items[0] : this.state.activeItem,
            query: canClearQuery ? "" : this.state.query,
        });
    };
    Omnibox.prototype.renderItems = function (_a) {
        var activeItem = _a.activeItem, filteredItems = _a.filteredItems, handleItemSelect = _a.handleItemSelect;
        var _b = this.props, itemRenderer = _b.itemRenderer, noResults = _b.noResults;
        if (filteredItems.length === 0) {
            return noResults;
        }
        return filteredItems.map(function (item, index) { return itemRenderer({
            index: index,
            item: item,
            handleClick: function (e) { return handleItemSelect(item, e); },
            isActive: item === activeItem,
        }); });
    };
    Omnibox.prototype.maybeRenderMenu = function (listProps) {
        if (this.state.query.length > 0) {
            return (React.createElement(core_1.Menu, { ulRef: listProps.itemsParentRef }, this.renderItems(listProps)));
        }
        return undefined;
    };
    return Omnibox;
}(React.Component));
Omnibox.displayName = "Blueprint.Omnibox";
Omnibox = Omnibox_1 = tslib_1.__decorate([
    PureRender
], Omnibox);
exports.Omnibox = Omnibox;
var Omnibox_1;

//# sourceMappingURL=omnibox.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@blueprintjs/labs/dist/components/omnibox/omnibox.js
// module id = AvCd
// module chunks = 1